import React, { useState, useEffect } from 'react';
import { getMeetings, deleteMeeting, getMeetingsAcl } from '../api';
import MeetingCard from '../card/MeetingCard';
import MeetingForm from '../form/MeetingForm';
import ListHeader from '../../../common/ui/components/ListHeader/ListHeader';
import DeleteConfirmation from '../../../common/ui/components/DeleteConfirmation/DeleteConfirmation';
import Pagination from '../../../common/ui/components/Pagination/Pagination';
import '../styles.scss';

const MeetingsList = () => {
    const [meetings, setMeetings] = useState([]);
    const [meetingsCount, setMeetingsCount] = useState(0);
    const [meetingsAcl, setMeetingsAcl] = useState({});
    const [shouldShowForm, setShouldShowForm] = useState(false);
    const [meetingToEdit, setMeetingToEdit] = useState(null);
    const [isDeleteConfirmationShowing, setIsDeleteConfirmationShowing] = useState(false);
    const [meetingIdToDelete, setMeetingIdToDelete] = useState(null);

    useEffect(() => {
        handlePageChange(1);

        const fetchMeetingsAcl = async () => {
            setMeetingsAcl(await getMeetingsAcl());
        };

        fetchMeetingsAcl();
    }, []);

    const handlePageChange = pageNumber => {
        const fetchMeetings = async () => {
            const data = await getMeetings(pageNumber);
            setMeetingsCount(data.count);
            setMeetings(data.meetings);
        };
        fetchMeetings();
    };
    const handleToggleForm = () => {
        setShouldShowForm(!shouldShowForm);
    };
    const handleEditMeeting = meetingData => {
        setMeetingToEdit(meetingData);
        setShouldShowForm(true);
    };
    const handleAddMeeting = meeting => {
        setShouldShowForm(false);
        setMeetings(meetings => [meeting, ...meetings]);
    };
    const handleUpdateMeeting = updatedMeeting => {
        setShouldShowForm(false);
        const indexOfUpdatedMeeting = meetings.findIndex(meeting => meeting._id === updatedMeeting._id);
        const updatedMeetings = [...meetings];
        updatedMeetings[indexOfUpdatedMeeting] = updatedMeeting;
        setMeetings(updatedMeetings);
        setMeetingToEdit(null);
    };
    const handleDeleteMeeting = async () => {
        if (!meetingIdToDelete) return;
        await deleteMeeting(meetingIdToDelete);
        const remainingMeetings = meetings.filter(meeting => {
            return meeting._id !== meetingIdToDelete;
        });

        setMeetings(remainingMeetings);
        setIsDeleteConfirmationShowing(false);
    };
    return (
        <div className="list meetings-list">
            {shouldShowForm ? (
                <MeetingForm
                    handleCancel={() => {
                        handleToggleForm();
                        setMeetingToEdit(null);
                    }}
                    handleAddMeeting={handleAddMeeting}
                    handleUpdateMeeting={handleUpdateMeeting}
                    meetingToEdit={meetingToEdit}
                />
            ) : (
                <>
                    <ListHeader listTitle="جلسات" handleOpenForm={meetingsAcl.create ? handleToggleForm : null} />
                    {meetings.map((meeting, index) => (
                        <MeetingCard
                            meeting={meeting}
                            handleDeleteMeeting={() => {
                                setMeetingIdToDelete(meeting._id);
                                setIsDeleteConfirmationShowing(true);
                            }}
                            handleEditMeeting={handleEditMeeting}
                            meetingsAcl={meetingsAcl}
                            key={index}
                        />
                    ))}
                    <Pagination count={meetingsCount} onChange={(e, pageNumber) => handlePageChange(pageNumber)} />
                    <DeleteConfirmation
                        onClose={() => {
                            setIsDeleteConfirmationShowing(false);
                        }}
                        onClickOk={() => {
                            handleDeleteMeeting();
                        }}
                        isOpen={isDeleteConfirmationShowing}
                    />
                </>
            )}
        </div>
    );
};

export default MeetingsList;
